/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiTransactionRelatedPersonCategory } from './InternalApiTransactionRelatedPersonCategory';
import {
    InternalApiTransactionRelatedPersonCategoryFromJSON,
    InternalApiTransactionRelatedPersonCategoryFromJSONTyped,
    InternalApiTransactionRelatedPersonCategoryToJSON,
    InternalApiTransactionRelatedPersonCategoryToJSONTyped,
} from './InternalApiTransactionRelatedPersonCategory';
import type { InternalApiTransactionRelatedPersonType } from './InternalApiTransactionRelatedPersonType';
import {
    InternalApiTransactionRelatedPersonTypeFromJSON,
    InternalApiTransactionRelatedPersonTypeFromJSONTyped,
    InternalApiTransactionRelatedPersonTypeToJSON,
    InternalApiTransactionRelatedPersonTypeToJSONTyped,
} from './InternalApiTransactionRelatedPersonType';

/**
 * A participant of transaction
 * @export
 * @interface InternalApiTransactionRelatedPerson
 */
export interface InternalApiTransactionRelatedPerson {
    /**
     * External unique person ID
     * @type {string}
     * @memberof InternalApiTransactionRelatedPerson
     */
    personId: string;
    /**
     * Human readable label
     * @type {string}
     * @memberof InternalApiTransactionRelatedPerson
     */
    displayName: string;
    /**
     * 
     * @type {InternalApiTransactionRelatedPersonType}
     * @memberof InternalApiTransactionRelatedPerson
     */
    type: InternalApiTransactionRelatedPersonType;
    /**
     * 
     * @type {InternalApiTransactionRelatedPersonCategory}
     * @memberof InternalApiTransactionRelatedPerson
     */
    category: InternalApiTransactionRelatedPersonCategory;
}



/**
 * Check if a given object implements the InternalApiTransactionRelatedPerson interface.
 */
export function instanceOfInternalApiTransactionRelatedPerson(value: object): value is InternalApiTransactionRelatedPerson {
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function InternalApiTransactionRelatedPersonFromJSON(json: any): InternalApiTransactionRelatedPerson {
    return InternalApiTransactionRelatedPersonFromJSONTyped(json, false);
}

export function InternalApiTransactionRelatedPersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionRelatedPerson {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'],
        'displayName': json['displayName'],
        'type': InternalApiTransactionRelatedPersonTypeFromJSON(json['type']),
        'category': InternalApiTransactionRelatedPersonCategoryFromJSON(json['category']),
    };
}

export function InternalApiTransactionRelatedPersonToJSON(json: any): InternalApiTransactionRelatedPerson {
    return InternalApiTransactionRelatedPersonToJSONTyped(json, false);
}

export function InternalApiTransactionRelatedPersonToJSONTyped(value?: InternalApiTransactionRelatedPerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'displayName': value['displayName'],
        'type': InternalApiTransactionRelatedPersonTypeToJSON(value['type']),
        'category': InternalApiTransactionRelatedPersonCategoryToJSON(value['category']),
    };
}

